import { useEffect, useRef } from 'react';
import { RelatedOutcome } from './types';

interface Pending {
  resolve: (outcome: RelatedOutcome) => void;
  started: boolean;
  fallback: RelatedOutcome;
}

export const useSettle = (locked: boolean) => {
  const pending = useRef<Pending>(undefined);

  const finish = (outcome: RelatedOutcome) => {
    pending.current?.resolve(outcome);
    pending.current = undefined;
  };

  useEffect(() => {
    if (!locked && pending.current?.started) finish(pending.current.fallback);
  }, [locked]);

  const run = (start: () => Promise<boolean>, fallback: RelatedOutcome) =>
    new Promise<RelatedOutcome>((resolve) => {
      pending.current = { resolve, started: false, fallback };
      void start().then((started) => {
        if (!pending.current) return;
        if (started) pending.current.started = true;
        else finish(fallback);
      });
    });

  return { run, finish };
};
